<template>
    <div>
        <h5 class="mt-1 mb-4">{{ $t('address_information').toUpper() }}</h5>
        <b-row class="mb-4">
            <b-col cols="12" md="6" class="mb">
                <b-card v-if="!showLoading" :header="$t('residence_address')" class="soft h-100">
                    <div class="label-as-input-div">
                        <label>{{ $t('address') }}</label>
                        <div class="height-80">{{ this.getObjectValue(studentProgram, 'address') }}</div>
                    </div>
                    <b-row>
                        <b-col cols="12" sm="6">
                            <div class="label-as-input-div">
                                <label>{{ $t('city') }}</label>
                                <div>{{ this.getObjectValue(studentProgram, 'address_city_name') }}</div>
                            </div>
                        </b-col>
                        <b-col cols="12" sm="6">
                            <div class="label-as-input-div">
                                <label>{{ $t('district') }}</label>
                                <div>{{ this.getObjectValue(studentProgram, 'address_district_name') }}</div>
                            </div>
                        </b-col>
                        <b-col cols="12" sm="6">
                            <div class="label-as-input-div">
                                <label>{{ $t('postal_code') }}</label>
                                <div>{{ this.getObjectValue(studentProgram, 'address_zip_code') }}</div>
                            </div>
                        </b-col>
                    </b-row>
                </b-card>
                <b-card v-if="showLoading" :header="$t('residence_address')" class="soft h-100 text-center">
                    <b-spinner label="Spinning"></b-spinner>
                </b-card>
                <b-button variant="primary"
                          @click="addressUpdate"
                          v-if="checkPermission('student_updatestudentaddressinformationfromkps') && editMode">
                    {{ $t('mernis_edit') }}
                </b-button>
            </b-col>
            <b-col cols="12" md="6" class="mb">
                <b-card :header="$t('communication_address')" class="soft h-100">
                    <div class="label-as-input-div">
                        <label>{{ $t('address') }}</label>
                        <div class="height-80">{{ this.getObjectValue(studentProgram, 'contact_address') }}</div>
                    </div>
                    <b-row>
                        <b-col cols="12" sm="6">
                            <div class="label-as-input-div">
                                <label>{{ $t('city') }}</label>
                                <div>{{ this.getObjectValue(studentProgram, 'contact_city_name') }}</div>
                            </div>
                        </b-col>
                        <b-col cols="12" sm="6">
                            <div class="label-as-input-div">
                                <label>{{ $t('district') }}</label>
                                <div>{{ this.getObjectValue(studentProgram, 'contact_district_name') }}</div>
                            </div>
                        </b-col>
                    </b-row>
                </b-card>
                <b-button variant="primary"
                          @click="updateFormShow"
                          v-if="checkPermission('studentprogram_updateaddress') && editMode">
                    {{ $t('edit') }}
                </b-button>
            </b-col>
        </b-row>

        <CommonModal ref="formModal"
                     :onHideOnlyX="true"
                     @bHideModalHeaderClose="clearFormData()"
                     v-if="checkPermission('studentprogram_updateaddress') && editMode">
            <template v-slot:CommonModalTitle>
                {{ $t('edit').toUpper() }}
            </template>
            <template v-slot:CommonModalContent>
                <update-form :studentProgram="studentProgram"
                             :edit-residence-address="editResidenceAddress"
                             @updateFormSuccess="updateFormSuccess()"
                             v-if="formProcess=='update'"
                />
            </template>
        </CommonModal>
    </div>
</template>
<script>
    // Component
    import CommonModal from '@/components/elements/CommonModal';
    import StudentService from "@/services/StudentService";

    // Pages
    import UpdateForm from './UpdateForm';

    export default {
        components: {
            CommonModal,
            UpdateForm
        },
        props: {
            studentProgram: {
                type: Object,
                default: null
            },
            editMode: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                formProcess: null,
                showLoading: false
            }
        },
        methods: {
            // Clear
            clearFormData() {
                this.formProcess = null
            },

            // Update
            updateFormShow() {
                this.formProcess = 'update'
                this.$refs.formModal.$refs.commonModal.show()
            },
            updateFormSuccess() {
                this.clearFormData();
                this.$refs.formModal.$refs.commonModal.hide()
                this.$emit('updatedData', true);
            },

            addressUpdate() {
                this.showLoading = true
                StudentService.updateContactInfoKps(this.studentProgram.student_number).then(response => {
                    this.$toast.success(this.$t('api.'+response.data.message))
                    this.$emit('updatedData', true);
                    this.showLoading = false
                }).catch(e => {
                    this.showErrors(e)
                })
            }
        }
    }
</script>

